import { createSelector } from 'reselect';
import { RootState } from '../core/store';
import { ISubscriptionState } from './appSlice';
import { TSector, TSubscribedMsiVessel, TSubscription, TVesselImageData } from './subscription/subscriptionTypes';
import { uniq, isEmpty, orderBy } from 'lodash';
import { TAuthSliceState, TSignedInUser } from './auth/authTypes';

const selectAuthData = createSelector(
  [(state: RootState) => state.appSlice],
  (appSlice) => appSlice.authData as TAuthSliceState
);

const selectSubscriptionData = createSelector(
  [(state: RootState) => state.appSlice],
  (appSlice) => appSlice.subscriptionData as ISubscriptionState
);


export const selectIsUserInfoLoading = createSelector([selectAuthData], (authData) => authData.isLoading as boolean);
export const selectIsAuthorized = createSelector([selectAuthData], (authData) => authData.isAuthorized as boolean);
export const selectError = createSelector([(state: RootState) => state.appSlice], (appSlice) => appSlice.error as string);
export const selectUserId = createSelector([selectAuthData], (authData) => authData.userInfo?.id as number);
export const selectSignedInUserInfo = createSelector([selectAuthData], (authData) => authData.userInfo as TSignedInUser);
export const selectSignedInUserPublishedScenarioName = createSelector([selectAuthData], (authData) => authData.userInfo?.lastPublishedScenarioName as string);
export const selectIsMsi = createSelector([selectAuthData], (authData) => authData.userInfo?.isMsi as boolean);

export const selectIsSubscriptionDataFetched = createSelector([selectSubscriptionData], (subscriptionData) => subscriptionData.isFetched as boolean);
export const selectSubscriptions = createSelector([selectSubscriptionData], (subscriptionData) => subscriptionData.userSubscriptions as TSubscription[]);
export const selectSelectedSubscription = createSelector([selectSubscriptionData], (subscriptionData) => subscriptionData.selectedSubscription as TSubscription);
export const selectSelectedSubscriptionId = createSelector([selectSubscriptionData], (subscriptionData) => subscriptionData.selectedSubscription.id as number);
export const selectTeamId = createSelector([selectSubscriptionData], (subscriptionData) => subscriptionData.selectedSubscription.teamId as number);
export const selectSubscribedSectors = createSelector([selectSubscriptionData], (subscriptionData) => subscriptionData.selectedSubscription.sectors as TSector[]);
export const selectSubscribedMsiVessels = createSelector([selectSubscriptionData], (subscriptionData) => subscriptionData.subscribedMsiVessels as TSubscribedMsiVessel[]);
export const selectSubscribedMsiOwnerships = createSelector([selectSubscribedMsiVessels], (subscribedMsiVessels) => orderBy(uniq(subscribedMsiVessels.filter(k => !isEmpty(k.owner)).map(v => (v.owner)))) as string[]);

export const selectVesselImageData = createSelector(
  [selectSubscriptionData, (_state, imoNumber: number) => imoNumber],
  (subscriptionData, imoNumber) => {
    const vesselImageData = subscriptionData.vesselImages.find(v => v.imoNumber === imoNumber);
    return vesselImageData as TVesselImageData;
  }
);

// Create a selector to return if user has trial subscription
export const selectIsUserOnTrial = createSelector(
  [selectSubscriptions],
  (subscriptions) => {
    if (!subscriptions || subscriptions.length === 0) return false;
    return subscriptions.some(sub => sub.isTrial);
  }
);